import styled from "styled-components";

import { colors } from "shared/ui/tokens";

export const Lead = styled.p`
    margin: 0;
    font-size: 13px;
    color: ${colors.textSecondary};
`;

export const FeatureList = styled.ul`
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const FeatureItem = styled.li`
    display: flex;
    align-items: flex-start;
    gap: 8px;
    font-size: 0.9375rem;
    color: ${colors.textPrimary};

    &::before {
        content: "✓";
        color: ${colors.success};
        line-height: 1.3;
    }
`;
